import axiosInstance from "../../utils/axiosInstance";

const testimonialService = {

    getList: async (page = 1, pageSize = 10, search = "") => {

        const response = await axiosInstance.get("/Testimonial", {
            params: {
                page,
                pageSize,
                search
            }
        });

        return response.data;
    },

    getById: async (id) => {

        const response = await axiosInstance.get(`/Testimonial/${id}`);

        return response.data;
    },

    create: async (data) => {

        const response = await axiosInstance.post(
            "/Testimonial",
            data
        );

        return response.data;
    },

    update: async (id, data) => {

        const response = await axiosInstance.put(
            `/Testimonial/${id}`,
            data
        );

        return response.data;
    },

    delete: async (id) => {

        const response = await axiosInstance.delete(
            `/Testimonial/${id}`
        );

        return response.data;
    }

};

export default testimonialService;